export default "__VITE_ASSET__BFooAGEE__"